import React from 'react'
import styled from 'styled-components'

const SectionV2 = ({
  style,
  className,
  id,
  title,
  subtitle,
  grey,
  children,
  noContainer,
}) => (
  <Wrapper
    style={style}
    className={`${className} question`}
    grey={grey}
    id={id}>
    {title && <Title>{title}</Title>}
    <Container>
      {React.Children.map(children, (child, i) => {
        if (React.isValidElement(child) && child.props['data-slot']) return
        return child
      })}
    </Container>
  </Wrapper>
)

export default SectionV2

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 32px 20px;
  align-items: flex-start;
  gap: 32px;
  border-bottom: 1px solid #ececec;
  background: #ffffff;
  max-width: 1200px;
  margin-inline: auto;

  @media screen and (min-width: 1300px) {
    padding-inline: 0px;
  }
`

const Container = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-shrink: 0;
  min-width: 576px;
`

const Title = styled.h2`
  color: #1d1e22;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Nunito;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 42px; /* 210% */
  letter-spacing: 0.5px;
  text-transform: uppercase;
  min-width: 270px;
  margin: 0;
`



// WEBPACK FOOTER //
// ./src/components/SectionV2/index.js